var GENOMES = 'genomes';
var GENOME_FILES = 'genomeFiles';
var GENOME_FILE_UPDATE = "".concat(GENOME_FILES, "/update");
var GENOME_FILE_DELETED = "".concat(GENOME_FILES, "/deleted");
var GENOME_FILE_CREATED = "".concat(GENOME_FILES, "/created");
var GENOMES_LOADING = "".concat(GENOMES, "/loading");
var GENOMES_CREATED = "".concat(GENOMES, "/created");
var GENOMES_LOADED = "".concat(GENOMES, "/loaded");
var GENOMES_UPDATED = "".concat(GENOMES, "/updated");
var GENOMES_ERROR = "".concat(GENOMES, "/error");
export { GENOME_FILE_DELETED, GENOME_FILE_CREATED, GENOME_FILE_UPDATE, GENOMES_LOADING, GENOMES_LOADED, GENOMES_ERROR, GENOMES_UPDATED, GENOMES_CREATED };